var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"image-size":"2.1rem","image":_vm.img_none_sj,"description":_vm.$t('notice._SemMensagem')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }